"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseMessages = void 0;
const baseMessages = exports.baseMessages = {
  termsWithMin: 'pricing.qualifiers.terms.multiYear',
  termsNoMin: 'pricing.qualifiers.terms.firstYear',
  icannFee: 'pricing.price-conditions-tooltip.icannFee',
  firstYearDiscount: 'pricing.price-conditions-tooltip.first-year-discount',
  firstYearDiscountBundle: 'pricing.price-conditions-tooltip.first-year-discount.bundle-annual-price',
  firstYearDiscountWithTerm: 'pricing.price-conditions-tooltip.first-year-discount-with-term',
  termsNoFirstYrDiscNoPromo: 'pricing.noFirstYearDiscount.noPromoOffer',
  samePriceEachYear: 'pricing.terms.consistent-pricing.tooltip',
  termsFirstYearPercentage: 'pricing.qualifiers.terms.first-year-with-percentage',
  currentPricePerYear: 'pricing.display.price-per-year',
  whenYouRenew: 'pricing.terms.renew',
  plusRenewal: 'pricing.display.additional-renewal-cost',
  freeLabel: 'pricing.display.free-label',
  premium: 'pricing.price-conditions-tooltip.premium',
  noDiscountTerms: 'pricing.price-conditions-tooltip.no-discount',
  pricingTitle: 'pricing.price-conditions-tooltip.pricing-header',
  newShopperPromo: 'pricing.price-conditions-tooltip.newShopperPromo',
  secondYear: 'pricing.secondYear',
  firstYear: 'pricing.firstYear',
  numberOfYearPrice: 'pricing.numberOfYearPrice',
  price: 'price',
  renewalText: 'pricing.terms.renew',
  percentageSavings: 'pricing.savePercent',
  moneySavings: 'pricing.saveMoney',
  domainbestValue: 'pricing.domainbestValue',
  total: 'pricing.total',
  yearTerm: 'pricing.yearTerm',
  domainRenews: 'pricing.domainRenews'
};